module.exports = __webpack_public_path__ + "img/LATIN10_27.c549e825.jpg";